module.exports = __webpack_public_path__ + "img/module_title.53ad5559.png";